export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date (isoformat) */
  Date: { input: any; output: any; }
  /** Date with time (isoformat) */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](https://ecma-international.org/wp-content/uploads/ECMA-404_2nd_edition_december_2017.pdf). */
  JSON: { input: any; output: any; }
};

export type UltraAddDetectionImageInput = {
  boundingBoxes: Array<UltraBoundingBoxObjectInput>;
  bucketFileName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  imageType: UltraImageTypeChoices;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UltraBoundingBoxObjectInput = {
  confidence?: InputMaybe<Scalars['Float']['input']>;
  coordinates: UltraLabelCoordinatesInput;
  id?: InputMaybe<Scalars['ID']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
};

export enum UltraCompanyChoices {
  CCI = 'CCI',
  CONA = 'CONA',
  DAI = 'DAI',
  DELICIOUS = 'DELICIOUS',
  MBF = 'MBF',
  PBV = 'PBV',
  REYES = 'REYES',
  SNOWFRUIT = 'SNOWFRUIT',
  SWIRE = 'SWIRE',
  TEST = 'TEST'
}

export type UltraCreateAnnotatedImageInput = {
  boundingBoxes?: Array<UltraCreateBoundingBoxInput>;
  bucketPath: Scalars['String']['input'];
  imageSource: UltraImageSource;
  imageUrl: Scalars['String']['input'];
  sourceCustomer?: InputMaybe<Scalars['String']['input']>;
};

export type UltraCreateBoundingBoxInput = {
  detectionConfidence: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  maxX: Scalars['Float']['input'];
  maxY: Scalars['Float']['input'];
  metaClass: UltraMetaClass;
  minX: Scalars['Float']['input'];
  minY: Scalars['Float']['input'];
  predictedUpcs?: Array<UltraCreatePredictedUPCInput>;
  tagId?: InputMaybe<Scalars['ID']['input']>;
  verifiedUpc?: InputMaybe<Scalars['String']['input']>;
};

export type UltraCreateFlagReasonOptionInput = {
  reason: Scalars['String']['input'];
  type: UltraFlaggedTypeChoices;
};

export type UltraCreateMLModelInput = {
  bucketPath: Scalars['String']['input'];
  company?: InputMaybe<UltraCompanyChoices>;
  datasetBucketDir?: InputMaybe<Scalars['String']['input']>;
  deployed: Scalars['Boolean']['input'];
  modelCategory: UltraMLModelCategoryChoices;
  modelType: UltraMLModelTypeChoices;
  platform: UltraPlatformChoices;
  version: Scalars['String']['input'];
};

export type UltraCreatePredictedUPCInput = {
  classifierId: Scalars['ID']['input'];
  classifierScore?: InputMaybe<Scalars['Float']['input']>;
  isFieldLabeled: Scalars['Boolean']['input'];
  predictionRank?: InputMaybe<Scalars['Int']['input']>;
  upc: Scalars['String']['input'];
};

export type UltraCreatePricingInput = {
  imageId: Scalars['String']['input'];
  pricing: Array<UltraPricingInput>;
};

export type UltraCreateSegmentAndStoreDemographicsInput = {
  name: Scalars['String']['input'];
  segmentAvgDemographics: Scalars['String']['input'];
  storesAvgDemographicsDict: Scalars['String']['input'];
};

export enum UltraDAIZeroCropSource {
  HISTORICAL = 'HISTORICAL',
  MLULTRA = 'MLULTRA'
}

export type UltraDAIZeroReviewCropIdentityInput = {
  cropId: Scalars['ID']['input'];
  source: UltraDAIZeroCropSource;
};

export type UltraDAIZeroReviewCropInput = {
  cropId: Scalars['ID']['input'];
  expectedUpc?: InputMaybe<Scalars['String']['input']>;
  manifestUpc: Scalars['String']['input'];
  source: UltraDAIZeroCropSource;
};

export type UltraDAIZeroReviewInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  first?: Scalars['Int']['input'];
  membership?: UltraDAIZeroReviewMembership;
  modelVersion?: InputMaybe<Scalars['String']['input']>;
  sort?: UltraDAIZeroReviewSort;
  source?: InputMaybe<UltraDAIZeroCropSource>;
  statuses?: InputMaybe<Array<UltraDAIZeroReviewStatus>>;
  upc: Scalars['String']['input'];
  verificationSources?: InputMaybe<Array<UltraDAIZeroVerificationSource>>;
};

export enum UltraDAIZeroReviewMembership {
  ALL_ELIGIBLE = 'ALL_ELIGIBLE',
  ELIGIBLE_NOT_IN_DAI_ZERO = 'ELIGIBLE_NOT_IN_DAI_ZERO',
  IN_DAI_ZERO = 'IN_DAI_ZERO'
}

export enum UltraDAIZeroReviewSort {
  CREATED_ASC = 'CREATED_ASC',
  CREATED_DESC = 'CREATED_DESC',
  FOCUS_ASC = 'FOCUS_ASC',
  FOCUS_DESC = 'FOCUS_DESC'
}

export enum UltraDAIZeroReviewStatus {
  EXCLUDED = 'EXCLUDED',
  RELABELED = 'RELABELED',
  UNCHANGED = 'UNCHANGED',
  UNVERIFIED = 'UNVERIFIED'
}

export enum UltraDAIZeroVerificationSource {
  BARCODE_SCAN = 'BARCODE_SCAN',
  HISTORICAL = 'HISTORICAL',
  WHITE_RABBIT = 'WHITE_RABBIT'
}

export type UltraFlagBoundingBoxesForCorrectionInput = {
  boxIds: Array<Scalars['ID']['input']>;
};

export type UltraFlagClassificationBatchInput = {
  boxIds: Array<Scalars['ID']['input']>;
  flagLevel?: InputMaybe<UltraFlaggedLevelChoices>;
  moreInfo?: InputMaybe<Scalars['String']['input']>;
  reasonOptionId?: InputMaybe<Scalars['ID']['input']>;
  reasonText?: InputMaybe<Scalars['String']['input']>;
};

export type UltraFlagClassificationCropInput = {
  boxId: Scalars['ID']['input'];
  flagLevel?: InputMaybe<UltraFlaggedLevelChoices>;
  moreInfo?: InputMaybe<Scalars['String']['input']>;
  reasonOptionId?: InputMaybe<Scalars['ID']['input']>;
  reasonText?: InputMaybe<Scalars['String']['input']>;
};

export type UltraFlagDetectionImageInput = {
  flagLevel?: InputMaybe<UltraFlaggedLevelChoices>;
  imageId: Scalars['ID']['input'];
  moreInfo?: InputMaybe<Scalars['String']['input']>;
  reasonOptionId?: InputMaybe<Scalars['ID']['input']>;
  reasonText?: InputMaybe<Scalars['String']['input']>;
};

export type UltraFlagObjectInput = {
  app?: InputMaybe<Scalars['String']['input']>;
  flagLevel?: InputMaybe<Scalars['String']['input']>;
  flaggedBy?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  issueTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  model?: InputMaybe<Scalars['String']['input']>;
  moreInfo?: InputMaybe<Scalars['String']['input']>;
  objectApp?: InputMaybe<Scalars['String']['input']>;
  objectId?: InputMaybe<Scalars['ID']['input']>;
  objectModel?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  reviewer?: InputMaybe<Scalars['String']['input']>;
};

export enum UltraFlaggedLevelChoices {
  DELETE = 'DELETE',
  FIX = 'FIX',
  N_REVIEW = 'N_REVIEW',
  RED = 'RED',
  SAVED = 'SAVED',
  UNFLAG = 'UNFLAG',
  YELLOW = 'YELLOW'
}

export enum UltraFlaggedTypeChoices {
  CLASSIFICATION_CROP = 'CLASSIFICATION_CROP',
  COMMON = 'COMMON',
  DETECTION_IMAGE = 'DETECTION_IMAGE',
  IMAGE = 'IMAGE',
  PRICE_ATTRIBUTION_SET = 'PRICE_ATTRIBUTION_SET'
}

export enum UltraImageSource {
  API = 'API',
  APP = 'APP',
  OTHER = 'OTHER'
}

export enum UltraImageTypeChoices {
  CR = 'CR',
  DEFAULT = 'DEFAULT',
  MBF = 'MBF',
  REYES = 'REYES',
  SNOWFRUIT = 'SNOWFRUIT'
}

export type UltraLabelCoordinatesInput = {
  maxX: Scalars['Float']['input'];
  maxY: Scalars['Float']['input'];
  minX: Scalars['Float']['input'];
  minY: Scalars['Float']['input'];
};

export enum UltraLabelingExplorerBoxStatus {
  CLOSE_TOP_2 = 'CLOSE_TOP_2',
  UNIDENTIFIED = 'UNIDENTIFIED',
  UNVERIFIED = 'UNVERIFIED',
  VERIFIED = 'VERIFIED'
}

export type UltraLabelingExplorerFiltersInput = {
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  maxBoxAcquisitionScore?: InputMaybe<Scalars['Float']['input']>;
  maxImageAcquisitionScore?: InputMaybe<Scalars['Float']['input']>;
  maxUnidentifiedCount?: InputMaybe<Scalars['Int']['input']>;
  minBoxAcquisitionScore?: InputMaybe<Scalars['Float']['input']>;
  minImageAcquisitionScore?: InputMaybe<Scalars['Float']['input']>;
  minUnidentifiedCount?: InputMaybe<Scalars['Int']['input']>;
  sourceCustomer?: InputMaybe<UltraCompanyChoices>;
  statuses?: InputMaybe<Array<UltraLabelingExplorerBoxStatus>>;
  upcs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UltraLabelingExplorerInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UltraLabelingExplorerFiltersInput>;
  first?: Scalars['Int']['input'];
  mode?: UltraLabelingExplorerMode;
  sort?: UltraLabelingExplorerSort;
};

export enum UltraLabelingExplorerMode {
  CROP = 'CROP',
  IMAGE = 'IMAGE'
}

export enum UltraLabelingExplorerSort {
  DATE_CREATED = 'DATE_CREATED',
  DATE_VERIFIED = 'DATE_VERIFIED'
}

export enum UltraMLModelCategoryChoices {
  BEVERAGES = 'BEVERAGES',
  GENERAL = 'GENERAL',
  PRODUCE = 'PRODUCE'
}

export enum UltraMLModelTypeChoices {
  DAI_ZERO = 'DAI_ZERO',
  META_DETECTOR = 'META_DETECTOR',
  PRODUCT_EMBEDDER = 'PRODUCT_EMBEDDER'
}

export enum UltraMetaClass {
  BEVERAGE = 'BEVERAGE',
  EMPTY_FACING = 'EMPTY_FACING',
  NON_BEVERAGE_PRODUCT = 'NON_BEVERAGE_PRODUCT',
  PRICE_TAG = 'PRICE_TAG'
}

export type UltraModifiedCentroidQuantityByPointInput = {
  centroid: UltraPointInput;
  quantity: Scalars['Int']['input'];
};

export enum UltraOperationMessageKind {
  ERROR = 'ERROR',
  INFO = 'INFO',
  PERMISSION = 'PERMISSION',
  VALIDATION = 'VALIDATION',
  WARNING = 'WARNING'
}

export enum UltraPlatformChoices {
  ANDROID = 'ANDROID',
  CLOUD = 'CLOUD',
  iOS = 'iOS'
}

export type UltraPointInput = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
  z: Scalars['Float']['input'];
};

export type UltraPriceAttributionGroupInput = {
  groupId?: InputMaybe<Scalars['ID']['input']>;
  priceTags: Array<UltraPriceTagInput>;
  productBoundingBoxIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UltraPriceTagInput = {
  isSale?: InputMaybe<Scalars['Boolean']['input']>;
  priceContents: Scalars['String']['input'];
  priceTagBoundingBoxId: Scalars['ID']['input'];
  priceType: UltraPriceTypeChoices;
};

export enum UltraPriceTypeChoices {
  BULK_OFFER = 'BULK_OFFER',
  BUY_X_GET_Y = 'BUY_X_GET_Y',
  MISC = 'MISC',
  SINGLE_SALE = 'SINGLE_SALE',
  STANDARD = 'STANDARD',
  UNKNOWN = 'UNKNOWN'
}

export type UltraPricingInfoInput = {
  multiPrice?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  salePrice?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UltraPricingInput = {
  pricing: UltraPricingInfoInput;
  upc: Scalars['String']['input'];
};

export type UltraRelabelDAIZeroCropsInput = {
  /** Select every crop matching these filters; first and after are ignored. */
  allMatching?: InputMaybe<UltraDAIZeroReviewInput>;
  crops?: Array<UltraDAIZeroReviewCropInput>;
  excludedCrops?: Array<UltraDAIZeroReviewCropIdentityInput>;
  modelVersion: Scalars['String']['input'];
  replacementUpc: Scalars['String']['input'];
};

export type UltraReviewDateRangeInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export enum UltraReviewFeedbackWorkflowEnum {
  CLASSIFICATION = 'CLASSIFICATION',
  CORRECTION = 'CORRECTION',
  DETECTION = 'DETECTION'
}

export type UltraReviewNavigationInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
};

export enum UltraReviewWorkflowEnum {
  CLASSIFICATION = 'CLASSIFICATION',
  CORRECTION = 'CORRECTION',
  DETECTION = 'DETECTION'
}

export type UltraSavePriceAttributionSetInput = {
  imageId: Scalars['ID']['input'];
  priceAttributionSetId?: InputMaybe<Scalars['ID']['input']>;
  priceAttributions: Array<UltraPriceAttributionGroupInput>;
  verify?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UltraSetDAIZeroCropExclusionInput = {
  /** Select every crop matching these filters; first and after are ignored. */
  allMatching?: InputMaybe<UltraDAIZeroReviewInput>;
  crops?: Array<UltraDAIZeroReviewCropInput>;
  excluded: Scalars['Boolean']['input'];
  excludedCrops?: Array<UltraDAIZeroReviewCropIdentityInput>;
  modelVersion: Scalars['String']['input'];
};

export enum UltraStatsBucketSize {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY'
}

export enum UltraStatsGranularity {
  AUTO = 'AUTO',
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY'
}

export enum UltraStoreTypeChoices {
  CONVENIENCE_RETAIL = 'CONVENIENCE_RETAIL',
  DRUG = 'DRUG',
  HOME_IMPROVEMENT = 'HOME_IMPROVEMENT',
  LARGE = 'LARGE',
  VALUE = 'VALUE'
}

export type UltraStoresInStatesInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  states: Array<Scalars['String']['input']>;
};

export type UltraSubmitClassificationBatchInput = {
  acceptedBoxIds: Array<Scalars['ID']['input']>;
  classificationReviewBatchId?: InputMaybe<Scalars['ID']['input']>;
  rejectedBoxIds: Array<Scalars['ID']['input']>;
  replacementUpc?: InputMaybe<Scalars['String']['input']>;
  upc: Scalars['String']['input'];
};

export type UltraSubmitClassificationCorrectionInput = {
  boxId: Scalars['ID']['input'];
  correctedUpc: Scalars['String']['input'];
};

export enum UltraTimePeriod {
  ALL_TIME = 'ALL_TIME',
  CUSTOM = 'CUSTOM',
  THIS_MONTH = 'THIS_MONTH',
  THIS_WEEK = 'THIS_WEEK',
  TODAY = 'TODAY'
}

export type UltraTractsInStatesInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  states: Array<Scalars['String']['input']>;
};

export type UltraUndoHistoricalDAIZeroRelabelsInput = {
  /** Select every crop matching these filters; first and after are ignored. */
  allMatching?: InputMaybe<UltraDAIZeroReviewInput>;
  crops?: Array<UltraDAIZeroReviewCropInput>;
  excludedCrops?: Array<UltraDAIZeroReviewCropIdentityInput>;
  modelVersion: Scalars['String']['input'];
};

export type UltraUnverifyDAIZeroCropsInput = {
  /** Select every crop matching these filters; first and after are ignored. */
  allMatching?: InputMaybe<UltraDAIZeroReviewInput>;
  crops?: Array<UltraDAIZeroReviewCropInput>;
  excludedCrops?: Array<UltraDAIZeroReviewCropIdentityInput>;
  modelVersion: Scalars['String']['input'];
};

export type UltraUpdateBoundingBoxesInput = {
  boundingBoxes: Array<UltraBoundingBoxObjectInput>;
  boxSetId: Scalars['ID']['input'];
  deletedBoxIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  verifiedBy?: InputMaybe<Scalars['ID']['input']>;
};

export type UltraUpdateFlaggedReasonInput = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum UltraVerificationDecisionChoices {
  FAIL = 'FAIL',
  PASS = 'PASS'
}

export enum UltraVerifiedLocationChoices {
  FIELD = 'FIELD',
  F_AND_WR = 'F_AND_WR',
  WHTE_RBT = 'WHTE_RBT'
}

export type UltraVerifyPointCloudInput = {
  excludedCentroids?: InputMaybe<Array<UltraPointInput>>;
  modifiedQuantitiesByPoint?: InputMaybe<Array<UltraModifiedCentroidQuantityByPointInput>>;
  pointCloudId?: InputMaybe<Scalars['ID']['input']>;
  verificationDecision: UltraVerificationDecisionChoices;
};

export enum UltraVersionBumpType {
  MAJOR = 'MAJOR',
  MINOR = 'MINOR',
  PATCH = 'PATCH'
}

export type UltraVisualSearchInput = {
  boxId?: InputMaybe<Scalars['ID']['input']>;
  imageBase64?: InputMaybe<Scalars['String']['input']>;
  sourceCustomers?: InputMaybe<Array<UltraCompanyChoices>>;
  topK?: Scalars['Int']['input'];
};

export type UltraBaseBoundingBoxObjectFragment = { __typename: 'BoundingBoxObjectType', id: string, label: string | null, groupId: string | null, coordinates: { __typename: 'LabelCoordinates', minX: number, maxX: number, minY: number, maxY: number } };

export type UltraCoordinatesFragmentFragment = { __typename: 'LabelCoordinates', minX: number, maxX: number, minY: number, maxY: number };

export type UltraDAIZeroReviewCropFieldsFragment = { __typename: 'DAIZeroReviewCrop', source: UltraDAIZeroCropSource, cropId: string, upc: string, imageUrl: string, minX: number, minY: number, maxX: number, maxY: number, excluded: boolean, replacementUpc: string | null, verified: boolean | null, created: any | null, inDaiZero: boolean, verificationSource: UltraDAIZeroVerificationSource | null };

export type UltraDAIZeroReviewMutationResultFieldsFragment = { __typename: 'DAIZeroReviewMutationResult', success: boolean, operationId: string, updatedCount: number, queued: boolean };

export type UltraReviewFeedbackFieldsFragment = { __typename: 'ReviewFeedback', id: string, workflow: UltraReviewFeedbackWorkflowEnum, targetId: string, note: string, reviewerEmail: string | null, createdAt: any };

export type UltraBeginReviewEditCorrectionMutationVariables = Exact<{
  boxId: Scalars['ID']['input'];
}>;


export type UltraBeginReviewEditCorrectionMutation = { beginReviewEditCorrection: { __typename: 'ClassificationCorrection', crop: { __typename: 'BoundingBox', id: string, sourceImageUrl: string, minX: number, maxX: number, minY: number, maxY: number, metaClass: UltraMetaClass, isHumanAdded: boolean, isHumanDeleted: boolean, isFlagged: boolean, verifiedUpc: string | null, currentUpc: string | null, leasedById: string | null, leasedAt: any | null, flagged: { __typename: 'FlaggedType', level: string, moreInfo: string | null, reasons: Array<{ __typename: 'FlaggedReasonType', type: UltraFlaggedTypeChoices, reason: string | null, resolved: boolean }> } | null }, candidates: Array<{ __typename: 'Product', id: string, upcA: string, name: string, brandName: string | null, marketingImageUrl: string | null, packaging: string | null }>, image: { __typename: 'AnnotatedImage', id: string, imageUrl: string } } | { __typename: 'LeaseLockError', code: string, message: string, retryAfterMs: number | null } | { __typename: 'NoItemsAvailableError', code: string, message: string } };

export type UltraBeginReviewEditCurrentClassificationMutationVariables = Exact<{
  boxId: Scalars['ID']['input'];
}>;


export type UltraBeginReviewEditCurrentClassificationMutation = { beginReviewEditCurrentClassification: { __typename: 'ClassificationBatch', upc: string, originalUpc: string | null, anchorWasReplaced: boolean, requiresAnchorReplacement: boolean, rejectedBoxIds: Array<string>, boundingBoxes: Array<{ __typename: 'BoundingBox', id: string, sourceImageUrl: string, minX: number, maxX: number, minY: number, maxY: number, metaClass: UltraMetaClass, isHumanAdded: boolean, isHumanDeleted: boolean, isFlagged: boolean, leasedById: string | null, leasedAt: any | null, flagged: { __typename: 'FlaggedType', level: string, moreInfo: string | null, reasons: Array<{ __typename: 'FlaggedReasonType', type: UltraFlaggedTypeChoices, reason: string | null, resolved: boolean }> } | null }> } | { __typename: 'LeaseLockError', code: string, message: string, retryAfterMs: number | null } | { __typename: 'NoItemsAvailableError', code: string, message: string } };

export type UltraCreateFlagReasonOptionMutationVariables = Exact<{
  input: UltraCreateFlagReasonOptionInput;
}>;


export type UltraCreateFlagReasonOptionMutation = { createFlagReasonOption: { __typename: 'FlagReasonOptionOutputType', option: { __typename: 'FlagReasonOption', id: string, type: UltraFlaggedTypeChoices, reason: string } } };

export type UltraFlagClassificationBatchMutationVariables = Exact<{
  input: UltraFlagClassificationBatchInput;
}>;


export type UltraFlagClassificationBatchMutation = { flagClassificationBatch: { __typename: 'ClassificationFlagBatchResult', success: boolean, boundingBoxes: Array<{ __typename: 'BoundingBox', id: string, isFlagged: boolean, leasedById: string | null }> } | { __typename: 'OperationInfo' } };

export type UltraFlagClassificationCropMutationVariables = Exact<{
  input: UltraFlagClassificationCropInput;
}>;


export type UltraFlagClassificationCropMutation = { flagClassificationCrop: { __typename: 'ClassificationFlagCropResult', boundingBox: { __typename: 'BoundingBox', id: string, isFlagged: boolean, leasedById: string | null, flagged: { __typename: 'FlaggedType', level: string, moreInfo: string | null, reasons: Array<{ __typename: 'FlaggedReasonType', type: UltraFlaggedTypeChoices, reason: string | null, resolved: boolean }> } | null } } | { __typename: 'OperationInfo' } };

export type UltraFlagDetectionImageMutationVariables = Exact<{
  input: UltraFlagDetectionImageInput;
}>;


export type UltraFlagDetectionImageMutation = { flagDetectionImage: { __typename: 'FlagDetectionImageResult', image: { __typename: 'AnnotatedImage', id: string, isFlagged: boolean, leasedById: string | null, flagged: { __typename: 'FlaggedType', level: string, moreInfo: string | null, reasons: Array<{ __typename: 'FlaggedReasonType', type: UltraFlaggedTypeChoices, reason: string | null }> } | null } } | { __typename: 'OperationInfo', messages: Array<{ __typename: 'OperationMessage', kind: UltraOperationMessageKind, message: string, field: string | null, code: string | null }> } };

export type UltraRelabelDAIZeroCropsMutationVariables = Exact<{
  input: UltraRelabelDAIZeroCropsInput;
}>;


export type UltraRelabelDAIZeroCropsMutation = { relabelDaiZeroCrops: { __typename: 'DAIZeroReviewMutationResult', success: boolean, operationId: string, updatedCount: number, queued: boolean } };

export type UltraReleaseBoundingBoxLeasesMutationVariables = Exact<{
  boxIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UltraReleaseBoundingBoxLeasesMutation = { releaseBoundingBoxLeases: { __typename: 'OperationInfo' } | { __typename: 'ReleaseBoundingBoxLeasesResult', ok: boolean } };

export type UltraRevertClassificationBatchMutationVariables = Exact<{
  input: UltraSubmitClassificationBatchInput;
}>;


export type UltraRevertClassificationBatchMutation = { revertClassificationBatch: { __typename: 'OperationInfo' } | { __typename: 'RevertClassificationBatchResult', ok: boolean } };

export type UltraSetDAIZeroCropExclusionMutationVariables = Exact<{
  input: UltraSetDAIZeroCropExclusionInput;
}>;


export type UltraSetDAIZeroCropExclusionMutation = { setDaiZeroCropExclusion: { __typename: 'DAIZeroReviewMutationResult', success: boolean, operationId: string, updatedCount: number, queued: boolean } };

export type UltraSubmitClassificationBatchMutationVariables = Exact<{
  input: UltraSubmitClassificationBatchInput;
}>;


export type UltraSubmitClassificationBatchMutation = { submitClassificationBatch: { __typename: 'OperationInfo' } | { __typename: 'SubmitClassificationBatchResult', success: boolean, acceptedBoxes: Array<{ __typename: 'BoundingBox', id: string, sourceImageUrl: string, minX: number, maxX: number, minY: number, maxY: number, metaClass: UltraMetaClass, isHumanAdded: boolean, isHumanDeleted: boolean, isFlagged: boolean, leasedById: string | null, leasedAt: any | null, flagged: { __typename: 'FlaggedType', level: string, moreInfo: string | null, reasons: Array<{ __typename: 'FlaggedReasonType', type: UltraFlaggedTypeChoices, reason: string | null, resolved: boolean }> } | null }>, rejectedBoxes: Array<{ __typename: 'BoundingBox', id: string, sourceImageUrl: string, minX: number, maxX: number, minY: number, maxY: number, metaClass: UltraMetaClass, isHumanAdded: boolean, isHumanDeleted: boolean, isFlagged: boolean, leasedById: string | null, leasedAt: any | null, flagged: { __typename: 'FlaggedType', level: string, moreInfo: string | null, reasons: Array<{ __typename: 'FlaggedReasonType', type: UltraFlaggedTypeChoices, reason: string | null, resolved: boolean }> } | null }>, undoAction: { __typename: 'UndoAction', mutationName: string, variablesPayload: string }, redoAction: { __typename: 'RedoAction', mutationName: string, variablesPayload: string } } };

export type UltraSubmitClassificationCorrectionMutationVariables = Exact<{
  input: UltraSubmitClassificationCorrectionInput;
}>;


export type UltraSubmitClassificationCorrectionMutation = { submitClassificationCorrection: { __typename: 'OperationInfo', messages: Array<{ __typename: 'OperationMessage', kind: UltraOperationMessageKind, message: string, field: string | null, code: string | null }> } | { __typename: 'SubmitClassificationCorrectionResult', success: boolean, boundingBox: { __typename: 'BoundingBox', id: string, verifiedUpc: string | null, leasedById: string | null, leasedAt: any | null } } };

export type UltraUndoHistoricalDAIZeroRelabelsMutationVariables = Exact<{
  input: UltraUndoHistoricalDAIZeroRelabelsInput;
}>;


export type UltraUndoHistoricalDAIZeroRelabelsMutation = { undoHistoricalDaiZeroRelabels: { __typename: 'DAIZeroReviewMutationResult', success: boolean, operationId: string, updatedCount: number, queued: boolean } };

export type UltraUnverifyDAIZeroCropsMutationVariables = Exact<{
  input: UltraUnverifyDAIZeroCropsInput;
}>;


export type UltraUnverifyDAIZeroCropsMutation = { unverifyDaiZeroCrops: { __typename: 'DAIZeroReviewMutationResult', success: boolean, operationId: string, updatedCount: number, queued: boolean } };

export type UltraUnverifyDetectionMutationVariables = Exact<{
  imageId: Scalars['ID']['input'];
  feedbackNote?: InputMaybe<Scalars['String']['input']>;
}>;


export type UltraUnverifyDetectionMutation = { unverifyImageDetections: { __typename: 'OperationInfo', messages: Array<{ __typename: 'OperationMessage', kind: UltraOperationMessageKind, message: string, field: string | null, code: string | null }> } | { __typename: 'VerifyImageDetectionsResult', imageId: string, success: boolean } };

export type UltraUnverifyClassificationBatchMutationVariables = Exact<{
  batchId: Scalars['ID']['input'];
  feedbackNote?: InputMaybe<Scalars['String']['input']>;
}>;


export type UltraUnverifyClassificationBatchMutation = { unverifyClassificationBatch: { __typename: 'LeaseLockError', code: string, message: string } | { __typename: 'NoItemsAvailableError', code: string, message: string } | { __typename: 'ReviewUnverifyResult', success: boolean } };

export type UltraUnverifyCorrectionMutationVariables = Exact<{
  boxId: Scalars['ID']['input'];
  feedbackNote?: InputMaybe<Scalars['String']['input']>;
}>;


export type UltraUnverifyCorrectionMutation = { unverifyCorrection: { __typename: 'LeaseLockError', code: string, message: string } | { __typename: 'NoItemsAvailableError', code: string, message: string } | { __typename: 'ReviewUnverifyResult', success: boolean } };

export type UltraClassificationPreviewContextQueryVariables = Exact<{
  boxId: Scalars['ID']['input'];
}>;


export type UltraClassificationPreviewContextQuery = { classificationPreviewContext: { __typename: 'ClassificationPreviewContext', sourceImageUrl: string, nearbyBoundingBoxes: Array<{ __typename: 'BoundingBox', id: string, minX: number, maxX: number, minY: number, maxY: number, metaClass: UltraMetaClass, isHumanDeleted: boolean, isFlagged: boolean, currentUpc: string | null, verifiedUpc: string | null }> } | null };

export type UltraDAIZeroReviewCropsQueryVariables = Exact<{
  input: UltraDAIZeroReviewInput;
}>;


export type UltraDAIZeroReviewCropsQuery = { daiZeroReviewCrops: { __typename: 'DAIZeroReviewConnection', modelVersion: string, modelDeployed: boolean, totalCount: number, manifestCount: number, eligibleCount: number, nextCursor: string | null, crops: Array<{ __typename: 'DAIZeroReviewCrop', source: UltraDAIZeroCropSource, cropId: string, upc: string, imageUrl: string, minX: number, minY: number, maxX: number, maxY: number, excluded: boolean, replacementUpc: string | null, verified: boolean | null, created: any | null, inDaiZero: boolean, verificationSource: UltraDAIZeroVerificationSource | null }> } };

export type UltraDAIZeroReviewModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type UltraDAIZeroReviewModelsQuery = { daiZeroReviewModels: Array<{ __typename: 'DAIZeroReviewModel', version: string, deployed: boolean, manifestAvailable: boolean }> };

export type UltraLabelingStatisticsQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  granularity?: InputMaybe<UltraStatsGranularity>;
}>;


export type UltraLabelingStatisticsQuery = { labelingStatistics: { __typename: 'LabelingStatistics', classification: { __typename: 'ClassificationStatistics', batches: { __typename: 'HistoricalMetric', bucketSize: UltraStatsBucketSize, series: Array<{ __typename: 'UserHistoricalSeries', email: string, results: Array<{ __typename: 'HistoricalCount', dateString: string, count: number }> }> }, crops: { __typename: 'HistoricalMetric', bucketSize: UltraStatsBucketSize, series: Array<{ __typename: 'UserHistoricalSeries', email: string, results: Array<{ __typename: 'HistoricalCount', dateString: string, count: number }> }> } }, detection: { __typename: 'DetectionStatistics', boxes: { __typename: 'HistoricalMetric', bucketSize: UltraStatsBucketSize, series: Array<{ __typename: 'UserHistoricalSeries', email: string, results: Array<{ __typename: 'HistoricalCount', dateString: string, count: number }> }> }, images: { __typename: 'HistoricalMetric', bucketSize: UltraStatsBucketSize, series: Array<{ __typename: 'UserHistoricalSeries', email: string, results: Array<{ __typename: 'HistoricalCount', dateString: string, count: number }> }> } }, correction: { __typename: 'CorrectionStatistics', corrections: { __typename: 'HistoricalMetric', bucketSize: UltraStatsBucketSize, series: Array<{ __typename: 'UserHistoricalSeries', email: string, results: Array<{ __typename: 'HistoricalCount', dateString: string, count: number }> }> } } } };

export type UltraUltraGetLoggedInUserQueryVariables = Exact<{ [key: string]: never; }>;


export type UltraUltraGetLoggedInUserQuery = { loggedInUser: { __typename: 'UserType', uuid: string, id: string, email: string, name: string, firstName: string, lastName: string, username: string, isActive: boolean, isStaff: boolean, isSuperuser: boolean, dateRemoved: any | null, companyName: string | null, roles: Array<string> } | null };

export type UltraLabelingExplorerQueryVariables = Exact<{
  input: UltraLabelingExplorerInput;
  includeImageBoxes?: Scalars['Boolean']['input'];
}>;


export type UltraLabelingExplorerQuery = { labelingExplorer: { __typename: 'LabelingExplorerConnection', totalCount: number, items: Array<{ __typename: 'LabelingExplorerItem', cursor: string, image: { __typename: 'LabelingExplorerImage', id: string, imageUrl: string, bucketPath: string, imageSource: string, sourceCustomer: UltraCompanyChoices | null, created: any, acquisitionScore: number | null, focusScore: number | null, detectionEntropyScore: number | null, recencyScore: number | null, unidentifiedCount: number, boxCount: number, closeConfidenceCount: number, verifiedBoxCount: number, unverifiedBoxCount: number, boundingBoxes?: Array<{ __typename: 'LabelingExplorerBox', id: string, minX: number, maxX: number, minY: number, maxY: number, metaClass: UltraMetaClass, detectionConfidence: number | null, isHumanAdded: boolean, isHumanDeleted: boolean, verifiedUpc: string | null, upcVerifiedAt: any | null, isVerified: boolean, currentUpc: string | null, classifierScoreMargin: number | null, acquisitionScore: number | null, focusScore: number | null, pixelArea: number | null, isUnidentified: boolean, predictedUpcs: Array<{ __typename: 'LabelingExplorerPredictedUPC', upc: string, classifierScore: number | null, classifierRank: number | null, displayIndex: number, isFieldLabeled: boolean }> }> }, box: { __typename: 'LabelingExplorerBox', id: string, minX: number, maxX: number, minY: number, maxY: number, metaClass: UltraMetaClass, detectionConfidence: number | null, isHumanAdded: boolean, isHumanDeleted: boolean, verifiedUpc: string | null, upcVerifiedAt: any | null, isVerified: boolean, currentUpc: string | null, classifierScoreMargin: number | null, acquisitionScore: number | null, focusScore: number | null, pixelArea: number | null, isUnidentified: boolean, predictedUpcs: Array<{ __typename: 'LabelingExplorerPredictedUPC', upc: string, classifierScore: number | null, classifierRank: number | null, displayIndex: number, isFieldLabeled: boolean }> } | null }>, pageInfo: { __typename: 'LabelingExplorerPageInfo', hasNextPage: boolean, nextCursor: string | null } } };

export type UltraNextBoundingBoxesForClassificationQueryVariables = Exact<{
  upc?: InputMaybe<Scalars['String']['input']>;
}>;


export type UltraNextBoundingBoxesForClassificationQuery = { nextBoundingBoxesForClassification: { __typename: 'ClassificationBatch', upc: string, activeUpc: string | null, originalUpc: string | null, anchorWasReplaced: boolean, requiresAnchorReplacement: boolean, rejectedBoxIds: Array<string>, classificationReviewBatchId: string | null, returnedFeedbackCount: number, reviewFeedback: { __typename: 'ReviewFeedback', id: string, workflow: UltraReviewFeedbackWorkflowEnum, targetId: string, note: string, reviewerEmail: string | null, createdAt: any } | null, boundingBoxes: Array<{ __typename: 'BoundingBox', id: string, sourceImageUrl: string, minX: number, maxX: number, minY: number, maxY: number, metaClass: UltraMetaClass, isHumanAdded: boolean, isHumanDeleted: boolean, isFlagged: boolean, currentUpc: string | null, leasedById: string | null, leasedAt: any | null, flagged: { __typename: 'FlaggedType', level: string, moreInfo: string | null, reasons: Array<{ __typename: 'FlaggedReasonType', type: UltraFlaggedTypeChoices, reason: string | null, resolved: boolean }> } | null }> } | { __typename: 'LeaseLockError', code: string, message: string, retryAfterMs: number | null } | { __typename: 'NoItemsAvailableError', code: string, message: string } };

export type UltraNextClassificationCorrectionQueryVariables = Exact<{
  upc?: InputMaybe<Scalars['String']['input']>;
}>;


export type UltraNextClassificationCorrectionQuery = { nextClassificationCorrection: { __typename: 'ClassificationCorrection', returnedFeedbackCount: number, reviewFeedback: { __typename: 'ReviewFeedback', id: string, workflow: UltraReviewFeedbackWorkflowEnum, targetId: string, note: string, reviewerEmail: string | null, createdAt: any } | null, crop: { __typename: 'BoundingBox', id: string, sourceImageUrl: string, minX: number, maxX: number, minY: number, maxY: number, metaClass: UltraMetaClass, isHumanAdded: boolean, isHumanDeleted: boolean, isFlagged: boolean, verifiedUpc: string | null, currentUpc: string | null, leasedById: string | null, leasedAt: any | null, flagged: { __typename: 'FlaggedType', level: string, moreInfo: string | null, reasons: Array<{ __typename: 'FlaggedReasonType', type: UltraFlaggedTypeChoices, reason: string | null, resolved: boolean }> } | null }, candidates: Array<{ __typename: 'Product', id: string, upcA: string, name: string, brandName: string | null, marketingImageUrl: string | null, packaging: string | null }>, image: { __typename: 'AnnotatedImage', id: string, imageUrl: string } } | { __typename: 'LeaseLockError', code: string, message: string, retryAfterMs: number | null } | { __typename: 'NoItemsAvailableError', code: string, message: string } };

export type UltraSearchFlagReasonOptionsQueryVariables = Exact<{
  type: UltraFlaggedTypeChoices;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type UltraSearchFlagReasonOptionsQuery = { searchFlagReasonOptions: Array<{ __typename: 'FlagReasonOption', id: string, type: UltraFlaggedTypeChoices, reason: string }> };

export type UltraVisualSearchQueryVariables = Exact<{
  input: UltraVisualSearchInput;
}>;


export type UltraVisualSearchQuery = { visualSearch: Array<{ __typename: 'LabelingExplorerItem', cursor: string, image: { __typename: 'LabelingExplorerImage', id: string, imageUrl: string, bucketPath: string, imageSource: string, sourceCustomer: UltraCompanyChoices | null, created: any, acquisitionScore: number | null, focusScore: number | null, detectionEntropyScore: number | null, recencyScore: number | null, unidentifiedCount: number, boxCount: number, closeConfidenceCount: number, verifiedBoxCount: number, unverifiedBoxCount: number }, box: { __typename: 'LabelingExplorerBox', id: string, minX: number, maxX: number, minY: number, maxY: number, metaClass: UltraMetaClass, detectionConfidence: number | null, isHumanAdded: boolean, isHumanDeleted: boolean, verifiedUpc: string | null, upcVerifiedAt: any | null, isVerified: boolean, currentUpc: string | null, classifierScoreMargin: number | null, acquisitionScore: number | null, focusScore: number | null, pixelArea: number | null, isUnidentified: boolean, predictedUpcs: Array<{ __typename: 'LabelingExplorerPredictedUPC', upc: string, classifierScore: number | null, classifierRank: number | null, displayIndex: number, isFieldLabeled: boolean }> } | null }> };
